import BaseStore from '../../BaseStore';
import MaintenanceTypeModel from '../../../models/Maintenance/WorkOrder/MaintenanceTypeModel';

class MaintenanceTypeStore extends BaseStore {
  constructor(transportLayer) {
    super(MaintenanceTypeModel, transportLayer);
  }
}

export default MaintenanceTypeStore;


// WEBPACK FOOTER //
// ./src/stores/Maintenance/WorkOrder/MaintenanceTypeStore.js